import { InfoTwoTone } from "@material-ui/icons";

const { default: CustomAddModal } = require("../../../../components/Common/CustomAddModal");

const EstimateCreateConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    contractType
}) => {
    const title = "Create Estimate Contract";

    let message = "";
    let subMessage = "";

    if (contractType === 'cargo-cargo') {
        message = "Create an estimate contract from this Cargo contract?";
        subMessage = "This will close the selected Cargo contract and create a new Estimate contract.";
    } else if (contractType === 'vessel-cargo') {
        message = "Create an estimate contract from these Vessel and Cargo contracts?";
        subMessage = "This will close both the selected Vessel and Cargo contracts and create a new Estimate contract.";
    } else if (contractType === 'vessel-vessel') {
        message = "Create an estimate contract from this Vessel contract?";
        subMessage = "This will close the selected Vessel contract and create a new Estimate contract.";
    }

    return (
        <CustomAddModal
            open={isOpen}
            title={title}
            maxWidth="md"
            saveLabel="Create"
            handleClose={onClose}
            onSubmitConfirm={onConfirm}
        >
            {/* Content */}
            <div className="px-6 py-8 text-center">
                <div className="mx-auto flex items-center justify-center rounded-full bg-blue-100 mb-6">
                    <InfoTwoTone className="h-16 w-16" color="primary" />
                </div>

                <h3 className="text-xl font-medium text-gray-900 mb-2">
                    {message}
                </h3>

                <p className="text-gray-600 mb-6">
                    {subMessage}
                </p>

                <div className="bg-rose-50 border border-rose-200 rounded-md p-4 mb-4">
                    <p className="text-darkRed text-sm">
                        Note: This action will change the status of the selected contract(s) to 'closed'.
                    </p>
                </div>
            </div>
        </CustomAddModal>
    );
};

export default EstimateCreateConfirmationModal